// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function isThemeWithMode(theme) {
    return (typeof theme === "undefined" ? "undefined" : _type_of(theme)) === 'object' && theme !== null && 'palette' in theme && _type_of(theme.palette) === 'object' && (isDarkMode(theme.palette.mode) || theme.palette.mode === 'light');
}
/**
 * Utility function to check if the current mode is dark mode.
 *
 * @param mode - The current theme mode
 * @returns true if the mode is 'dark', false otherwise
 */ export var isDarkMode = function(mode) {
    if (isThemeWithMode(mode)) {
        return mode.palette.mode === 'dark';
    }
    return mode === 'dark';
};

//# sourceMappingURL=types.js.map